export enum CoreRoute {
  RedirectionLoader = 'run',
}

export enum CoreRouteParam {
  AccessHash = 'mhbAccessHash',
}
